/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Range_ApplyInputs */

const cs_calendar_range_apply = /** @type {(inputs: Calendar_Range_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít rozsah`)
};

const en_calendar_range_apply = /** @type {(inputs: Calendar_Range_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply range`)
};

/**
* | output |
* | --- |
* | "Apply range" |
*
* @param {Calendar_Range_ApplyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_range_apply = /** @type {((inputs?: Calendar_Range_ApplyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Range_ApplyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_range_apply(inputs)
	return cs_calendar_range_apply(inputs)
});